import { QuickDrawServiceAPI } from '../services/QuickDrawServiceAPI';
import { addAudio, addTextureBase64, loadAssets } from '../utils/AssetLoader';

export class PreloadingScene extends Phaser.Scene {
  // @ts-ignore
  private lastTextureToBeLoaded;

  constructor() {
    super('PreloadingScene');
  }

  preload() {
    this.preloadImages();
    this.preLoadAudio();
    // Listen to texture load
    loadAssets(this, this.onLoadAssetsStart, this.onLoadAssetsComplete);
  }

  preLoadAudio() {
    addAudio('bonus_win', require('../assets/default/audio/Bright Bonus Win.wav').default);
    addAudio('wheel', require('../assets/default/audio/digital prize wheel.wav').default);
  }

  preloadImages() {
    addTextureBase64('background', require('../assets/default/Background.png').default);
    addTextureBase64('backgroundArc', require('../assets/default/BackgroundArc.png').default);
    addTextureBase64('topbar', require('../assets/default/Top bar.png').default);
    addTextureBase64('drawingid', require('../assets/default/drawingid_button.png').default);
    addTextureBase64('play', require('../assets/default/play.png').default);
    addTextureBase64('replay', require('../assets/default/replay.png').default);
    addTextureBase64('pause', require('../assets/default/pause.png').default);
    addTextureBase64('edit', require('../assets/default/edit.png').default);
    addTextureBase64('next_draw', require('../assets/default/next_draw.png').default);
    addTextureBase64('ticker', require('../assets/default/ticker.png').default);
    addTextureBase64('get_ready', require('../assets/default/get_ready.png').default);
    addTextureBase64('done', require('../assets/default/done.png').default);
    addTextureBase64('ttwlogo', require('../assets/default/2TWLogo.png').default);
    addTextureBase64('radial_burst', require('../assets/default/radial-burst.png').default);
    addTextureBase64('green_blank_ball', require('../assets/default/ball-stroke-green-large-blank.png').default);
    addTextureBase64('superBonus', require('../assets/default/superBonus/superBonus.png').default);
    addTextureBase64('finalSuperBonus', require('../assets/default/superBonus/finalSuperBonus.png').default);
    addTextureBase64('winningNumbers', require('../assets/default/superBonus/winningNumbers.png').default);
    addTextureBase64('Bonus1', require('../assets/default/superBonus/Bonus1.png').default);
    addTextureBase64('Bonus2', require('../assets/default/superBonus/Bonus2.png').default);
    addTextureBase64('Bonus3', require('../assets/default/superBonus/Bonus3.png').default);
    addTextureBase64('Bonus4', require('../assets/default/superBonus/Bonus4.png').default);
    addTextureBase64('Bonus5', require('../assets/default/superBonus/Bonus5.png').default);

    for (let i = 1; i < 6; i++) {
      addTextureBase64('spin' + i, require('../assets/default/superBonus/spin' + i + '.png').default);
    }

    for (let i = 0; i < 6; i++) {
      addTextureBase64('countdown_' + i, require('../assets/default/countdown/Countdown_' + i + '.png').default);
    }
    for (let i = 1; i < 10; i++) {
      addTextureBase64('whiteball_' + i, require('../assets/default/White-Balls/ball-stroke-0' + i + '.png').default);
    }
    for (let i = 1; i < 10; i++) {
      addTextureBase64('greenball_' + i, require('../assets/default/Green-Balls/ball-stroke-0' + i + '.png').default);
    }
    for (let i = 0; i <= 9; i++) {
      addTextureBase64('greennumberball_' + i, require('../assets/default/Green-Balls/ball-stroke-0' + i + '.png').default);
    }
    for (let i = 0; i <= 9; i++) {
      addTextureBase64('whitenumberball_' + i, require('../assets/default/White-Balls/ball-stroke-0' + i + '.png').default);
    }
  }

  private onLoadAssetsStart = () => {
    const screenWidth = 750;
    const screenHeight = 1334;
    this.add
      .text(screenWidth / 2, screenHeight / 2, 'Loading game...', {
        font: '40px Jost-SemiBold',
        color: '#000000'
      })
      .setOrigin(0.5);
  };

  private onLoadAssetsComplete = () => {
    window._po_gm.ready();
    //Uncomment this to start the game locally
    //window.po_gm.start({
    //  gameId: 199,
    //  drawId: '1',
    //  drawResult: [3, 8, 1],
    //  availableDraws: {}
    //});
    if (!window._po_gm.config) {
      this.makeDefaultConfigAndStartGame();
    }
  };

  create() {
    if (!!window._po_gm.config && !!window._po_gm.config.errorMsg) {
      this.scene.start('ErrorScene');
    }
  }

  getGameId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const gameId = urlParams.get('gameId');
    if (!!gameId) {
      return parseInt(gameId ? gameId : '0', 10);
    } else {
      return null;
    }
  }

  makeDefaultConfigAndStartGame() {
    const gameId = this.getGameId();
    if (!gameId) return;
    QuickDrawServiceAPI.getLatestQuickDrawWithWinnerResultByGame(gameId).then(response => {
      const config = {
        gameId,
        drawId: response.drawId,
        drawResult: response.drawResult,
        availableDraws: {}
      };
      window.po_gm.start(config);
    });
  }
}
